import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ApolusService } from '../services/apolus.service';
import { AppService } from 'common-cloudstudio';
import { ApolusProxyService, ApolusTypes } from '../services/apolus-proxy.service';

@Injectable({
  providedIn: 'root'
})

export class LiteralsResolver implements Resolve<ApolusTypes.ApolusCommonLiterals> {
  constructor(
    private apolusService: ApolusService,
    private appService: AppService,
    private apolusProxyService: ApolusProxyService
  ) {}

  resolve(
    route?: ActivatedRouteSnapshot,
    state?: RouterStateSnapshot
  ): Observable<any>|Promise<any>|any {
    return new Promise((resolve, reject) => {
      if (this.apolusService.literals !== null) {
        resolve(this.apolusService.literals);
        return;
      }
      this.appService.startLoading();
      this.apolusProxyService.ApolusService.GetApolusLiterals(
        this.appService.getAccessToken(),
        res => {
          this.appService.stopLoading();
          this.apolusService.setLiterals(res);
          resolve(res);
        }, err => {
          this.appService.stopLoading();
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }
}